import React, { useState, useEffect } from "react";
import { Box, TextField, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";

export function TagsKanbanFilter({ onFiltered, brandId }) {
  const [boards, setBoards] = useState([]);
  const [filteredBoards, setFilteredBoards] = useState([]);
  const [lanes, setLanes] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);

  const [selectedBoard, setSelectedBoard] = useState("");
  const [selectedLane, setSelectedLane] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const { data } = await api.get("/kanban-boards");
        setBoards(data);
      } catch (err) {
        toastError(err);
      }
    };
    fetchBoards();
  }, []);

  useEffect(() => {
    if (brandId) {
      setFilteredBoards(boards.filter(b => b.brandId === brandId));
    } else {
      setFilteredBoards(boards);
    }
  }, [brandId, boards]);

  useEffect(() => {
    if (!selectedBoard || !brandId) return;
    const board = boards.find((b) => b.id === selectedBoard);
    if (board && board.brandId !== brandId) {
      handleBoardChange("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId]);

  // IDs de las conexiones asignadas a un embudo (para filtrar el selector de Conexión)
  const getBoardWhatsappIds = (boardId) => {
    const board = boards.find((b) => b.id === boardId);
    return board && Array.isArray(board.whatsapps) ? board.whatsapps.map((w) => w.id) : [];
  };

  const handleBoardChange = async (boardId) => {
    setSelectedBoard(boardId);
    setSelectedLane("");
    setSelectedTags([]);
    setLanes([]);
    setAvailableTags([]);
    onFiltered({ boardId, boardWhatsappIds: getBoardWhatsappIds(boardId), laneId: "", tags: [] });

    if (boardId) {
      try {
        const { data } = await api.get("/tag/kanban/", {
          params: { kanbanBoardId: boardId }
        });
        setLanes(data.lista || []);
      } catch (err) {
        toastError(err);
      }
    }
  };

  const handleLaneChange = (laneId) => {
    setSelectedLane(laneId);
    setSelectedTags([]);
    setAvailableTags([]);

    let filterTags = [];

    if (laneId) {
      const laneObj = lanes.find(l => l.id == laneId);
      if (laneObj && laneObj.kanbanLaneTags && laneObj.kanbanLaneTags.length > 0) {
        const laneSpecificTags = laneObj.kanbanLaneTags.map(klt => klt.tag).filter(t => t);
        setAvailableTags(laneSpecificTags);
      } else {
        setAvailableTags([]);
      }
      filterTags = []; 
    }

    onFiltered({ boardId: selectedBoard, boardWhatsappIds: getBoardWhatsappIds(selectedBoard), laneId, tags: [] });
  };

  const handleTagsChange = (value) => {
    setSelectedTags(value);
    onFiltered({ boardId: selectedBoard, boardWhatsappIds: getBoardWhatsappIds(selectedBoard), laneId: selectedLane, tags: value.map(t => t.id) });
  };

  
  return (
    <>
      <TextField
        select
        variant="outlined"
        size="small"
        style={{ flex: 1, minWidth: 200 }}
        label="Embudo Kanban"
        value={selectedBoard}
        onChange={(e) => handleBoardChange(e.target.value)}
      >
        <MenuItem value="">
          <em>Ninguno</em>
        </MenuItem>
        {filteredBoards.map((b) => (
          <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        variant="outlined"
        size="small"
        style={{ flex: 1, minWidth: 200 }}
        label="Etapa del Embudo"
        value={selectedLane}
        onChange={(e) => handleLaneChange(e.target.value)}
        disabled={!selectedBoard}
      >
        <MenuItem value="">
          <em>Ninguna</em>
        </MenuItem>
        {lanes.map((l) => (
          <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>
        ))}
      </TextField>

      <Autocomplete
        multiple
        size="small"
        options={availableTags}
        value={selectedTags}
        onChange={(e, v) => handleTagsChange(v)}
        getOptionLabel={(option) => option.name}
        disabled={!selectedLane || availableTags.length === 0}
        style={{ flex: 1, minWidth: 200 }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: option.color || "#eee",
                textShadow: "1px 1px 1px #000",
                color: "white",
              }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Etiquetas de Etapa"
          />
        )}
      />
    </>
  );

}
